module.exports = __webpack_public_path__ + "img/set_theme_1.0727bd06.png";